import styled from "styled-components";
import {AdvancedGamesFilterFooterDefaultBox} from "./advanced-games-filter-footer.default";

export const AdvancedGamesFilterFooterMrGreenBox = styled(AdvancedGamesFilterFooterDefaultBox)`
    margin-left: -1.5rem;
    margin-right: -1.5rem;
    background-color: ${props => props.theme.colors.background};
`;
